// utils太多了，目前很多都不是公共的，需要用到的自己加
import * as dataUtils from '@/utils/dateUtils';
import * as urlUtils from '@/utils/urlUtils';
import * as kuShareUtils from '@/utils/kuShare';

export default {
    dataUtils,
    urlUtils,
    kuShareUtils,
};
